import moment from "moment";
import JwtService from "@/services/jwt.service";
import { charges_cargo } from "../config/ports-charges";
import {
  getRoRoCharges,
  getReeferCharges,
  getTransitCharges
} from "./charges-calculator.service";

const commonServices = {
  getTimestamp() {
    const today = new Date();

    const date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    const time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    const timestamp = date + " " + time;
    return timestamp;
  },
  getExpiryDate(date, duration) {
    const fm = moment(date)
      .add(duration, "months")
      .calendar();
    return fm;
  },
  getCurrentDate() {
    return moment().format("YYYY-MM-DD");
  },
  getCurrentUser() {
    return JwtService.getUser() ? JwtService.getUser()["username"] : " ";
  },
  getUserModules() {
    return JwtService.getUser() ? JwtService.getUser()["access_modules"] : " ";
  },
  getUserGroup() {
    return JwtService.getUser() ? JwtService.getUser()["user_role"] : " ";
  },
  getDaysSpend(start, arrival_date, is_transit, end) {
    if (is_transit) {
      if (arrival_date && end) {
        const a = moment(arrival_date, "YYYY-MM-DD");
        const e = moment(end, "YYYY-MM-DD");
        return moment.duration(e.diff(a)).asDays();
      } else {
        return "N/A";
      }
    } else {
      if (start && end) {
        const s = moment(start, "YYYY-MM-DD");
        const e = moment(end, "YYYY-MM-DD");
        return moment.duration(e.diff(s)).asDays();
      } else if (!is_transit && !start) {
        return 0;
      } else {
        return "N/A";
      }
    }
  }
};

const portChargesCalculator = (days, hrs, type, cargo_type, items) => {
  const sh_charges = 750;
  const sh_charges_40ft = 1500;
  const sh_charges_45ft = 1687.6;
  const cargo_list = items ? items : null;
  // console.log("days in service", days);
  //console.log("cargo list", cargo_type)

  if (cargo_type === "Full Container" && type === "LOCAL") {
    //console.log("charges 1", charges_cargo);
    const charge = charges_cargo.find(
      charges_cargo => days <= charges_cargo.end && days >= charges_cargo.start
    );

    if (charge !== undefined) {
      let count_45ft = 0;
      let count_40ft = 0;
      let count_20ft = 0;
      let count_reefer = 0;
      let fee_reefer = 0;

      for (let item in cargo_list) {
        if (cargo_list[item].cargo_size === 45) ++count_45ft;
        if (cargo_list[item].cargo_size === 40) ++count_40ft;
        if (cargo_list[item].cargo_size === 20) ++count_20ft;
        if (cargo_list[item].is_reefer) ++count_reefer;
      }
      // console.log("count reefer", count_reefer);
      // console.log("40 ft count", count_40ft);
      //console.log("20 ft count", count_20ft);
      const charges_45ft =
        sh_charges_45ft * count_45ft + charge.fee * 2 * count_45ft;
      const charges_40ft =
        sh_charges_40ft * count_40ft + charge.fee * 2 * count_40ft;
      const charges_20ft = sh_charges * count_20ft + charge.fee * count_20ft;
      // console.log("charges for 40: ", charges_40ft);
      // console.log("charges for 20: ", charges_20ft);

      if (count_reefer > 0) {
        const reefer_charges = getReeferCharges(count_reefer, hrs, items)
          ? getReeferCharges(count_reefer, hrs, items)
          : 0;

        fee_reefer = reefer_charges;
       // console.log("reefer charges", fee_reefer);
      }

      const total_shore_handling = sh_charges_45ft * count_45ft + sh_charges_40ft * count_40ft + sh_charges * count_20ft;
      const fee = charges_45ft + charges_40ft + charges_20ft + fee_reefer;
     // console.log("fee local", fee);
      return { fee: fee, shore_handling: total_shore_handling };
    }
  //  console.log("charges 2 local", charge);
  }

  if (cargo_type === "Full Container" && type === "TRANSIT") {
    const fee = getTransitCharges(days, hrs, cargo_type, items);
    return fee;
  }

  if (cargo_type === "RoRo") {
    const fee = getRoRoCharges(days, cargo_type, items);
    // console.log("roro", getRoRoCharges(days, cargo_type, items));
   // console.log("roro charges", fee);
    return fee;
  }

  //
};

const getPeriod = (days) => {
  const period = charges_cargo.find(
    charges_cargo => days <= charges_cargo.end && days >= charges_cargo.start
  );
  return period;
};

export { commonServices, portChargesCalculator, getPeriod };
